import React, { useState, useEffect } from "react";
import styles from "./Register.module.scss";
import LoginPic from "../../Assets/img/register.svg";
import axios from "axios";
import Home from "../Home/Home";
import swal from "sweetalert";
import { Spinner } from "react-bootstrap";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import ReactCodeInput from "react-verification-code-input";
import { TbEdit } from "react-icons/tb";
import GetCodeImg from "../../Assets/img/code.svg";
import { useNavigate } from "react-router-dom";

function Register() {
  const navigate = useNavigate();
  const [sendCode, setSendCode] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [giftcode, setGiftcode] = useState("");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("token") !== null) {
      navigate("/home");
    }
  }, [navigate]);

  if (localStorage.getItem("token") !== null) {
    return <Home />;
  }

  const onChangeName = (e) => setName(e.target.value);
  const onChangePhone = (e) => setPhone(e.target.value);
  const onChangeGiftcode = (e) => setGiftcode(e.target.value);
  const onChangeCode = (value) => setCode(value);

  const register = () => {
    setLoader(true);

    if (name.length === 0) {
      swal({
        title: "خطا!",
        text: "!فیلد نام را پرکنید",
        icon: "error",
        button: "باشه!",
      });
      setLoader(false);
      return;
    }

    if (phone.length === 0) {
      swal({
        title: "!خطا",
        text: "!فیلد شماره تماس را پر کنید",
        icon: "error",
        button: "!باشه",
      });
      setLoader(false);
      return;
    }

    if (giftcode !== "instagram" && giftcode.length !== 0) {
      swal({
        title: "!خطا",
        text: "!کد تخفیف نامعتبر است",
        icon: "error",
        button: "!باشه",
      });
      setLoader(false);
      return;
    }

    axios
      .post("https://arianaapp.arianaapply.com/api/V1/register", {
        name: name,
        phone: phone,
        code: giftcode,
        type_App: "pwa",
      })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          setSendCode(true);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        swal({
          title: "!خطا",
          text: "!شماره تماس قبلا ثبت شده است",
          icon: "error",
          button: "!باشه",
        });
        setLoader(false);
      });
  };

  const login = () => {
    setLoader(true);

    if (code.length === 0) {
      swal({
        title: "!خطا",
        text: "!فیلد کد را پر کنید",
        icon: "error",
        button: "!باشه",
      });
      setLoader(false);
      return;
    }

    axios
      .post("https://arianaapp.arianaapply.com/api/V1/login", {
        phone: phone,
        password: code,
      })
      .then((response) => {
        setLoader(false);
        console.log(response);
        if (response.data.status === 500) {
          swal({
            title: "!خطا",
            text: "!کد وارد شده نامعتبر است",
            icon: "error",
            button: "!باشه",
          });
        } else {
          localStorage.setItem("token", response.data.api_token);
          navigate("/home");
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  return (
    <>
      {sendCode ? (
        <div className={styles.getCode}>
          <div className={styles.getCodeBody}>
            <img src={GetCodeImg} alt="" />

            <div className={styles.getCodeTitle}>
              <h2>کد اعتبار سنجی</h2>
            </div>

            <div className={styles.getCodeText}>
              <p>
                کد ورود شما به شماره <strong>{phone}</strong> ارسال شد
              </p>
            </div>

            <div
              className={styles.editPhone}
              onClick={() => window.location.reload()}
            >
              <TbEdit />
              <span>ویرایش شماره</span>
            </div>

            <div className={styles.getCodeInput}>
              <ReactCodeInput
                className={styles.codeInput}
                fields={5}
                onChange={onChangeCode}
              />
            </div>

            <div className={styles.loginCodeBtn}>
              <button onClick={login}>
                {loader === false ? (
                  <span>ورود</span>
                ) : (
                  <Loader
                    type="TailSpin"
                    color="white"
                    height={30}
                    width={30}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.register}>
          <div className={styles.registerBody}>
            <img src={LoginPic} alt="register" />

            <div className={styles.registerTitle}>
              <h2>ثبت نام</h2>
            </div>

            <div className={styles.registerInputs}>
              <div className={styles.registerInput}>
                <span>نام و نام خانوادگی:</span>
                <input
                  type="text"
                  name="name"
                  placeholder=" مهدی بهرامی"
                  onChange={onChangeName}
                  value={name}
                />
              </div>
              <div className={styles.registerInput}>
                <span>شماره تماس:</span>
                <input
                  type="number"
                  name="phone"
                  placeholder=" 0912xxxxxxx"
                  onChange={onChangePhone}
                  value={phone}
                />
              </div>
              <div className={styles.registerInput}>
                <span>کدتخفیف:</span>
                <input
                  type="text"
                  name="giftcode"
                  placeholder="ARIANAPARS"
                  onChange={onChangeGiftcode}
                  value={giftcode}
                />
              </div>
            </div>

            <div className={styles.registerBtns}>
              <button
                className={styles.registerBtn}
                type="button"
                onClick={register}
              >
                {loader === false ? (
                  <span>ثبت نام</span>
                ) : (
                  <Spinner animation="border" variant="light" />
                )}
              </button>

              <button
                className={styles.loginBtn}
                onClick={() => navigate("/login")}
              >
                قبلا ثبت نام کرده اید؟
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Register;